import {
  avlStatusValues,
  supplierRoleStatusValues,
} from '@standandforce/api-contract';
import { z } from 'zod';

import { dataGridSearchFields } from '@/features/dynamic-table';

export const SupplierTableFilterSchema = z.object({
  ...dataGridSearchFields,
  freeText: z.string().optional(),
  supplierStatusIn: z
    .array(z.enum(supplierRoleStatusValues))
    .default(['OPERATING']),
  avlStatusIn: z.array(z.enum(avlStatusValues)).optional(),
});

export type SupplierTableFilterSchema = z.infer<
  typeof SupplierTableFilterSchema
>;
